import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { v4 as uuid } from 'uuid';

@inject('preview', 'draftStore', 'dialogStore')
@observer
class SnippetItem extends React.Component {
  prefix = /^[MATCH](\.data)?\./;
  guid = /[0-9a-f]{8}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{12}$/;

  render() {
    let { name, description } = this.props.snippet;

    return (
      <div className="snippet-item nowrap flex-row" onClick={this.onPreview}>
        <div className="flex-both">
          <div>
            <strong>{name}</strong>
          </div>
          <div>{description}</div>
        </div>
        <div className="flex-none">
          <div>
            <a onClick={this.onInsertBound}>Insert With Reporting Fields</a>
          </div>
          <div>
            <a onClick={this.onInsertTemplate}>Insert Without Reporting Fields</a>
          </div>
        </div>
      </div>
    );
  }

  @action.bound
  onPreview() {
    let { preview, snippet } = this.props;
    preview.load(snippet.body, {});
  }

  @action.bound
  onInsertBound() {
    let { snippet, draftStore, dialogStore } = this.props;
    let body = JSON.parse(snippet.body);

    let { type, reportingFields } = draftStore;

    Object.keys(body.entityMap).forEach((x) => {
      let { field } = body.entityMap[x].data;
      if (!reportingFields.some((r) => r.key === field.charAt(0))) {
        const _field = field.replace(this.prefix, '').replace(this.guid, '');
        body.entityMap[x].data.field = `${type}.data.${_field}${uuid()}`;
      }
    });

    body = this.processFormulaVariables(body);
    draftStore.insertTemplateAndUpdate(body);
    dialogStore.open = false;
  }

  @action.bound
  onInsertTemplate() {
    let { snippet, draftStore, dialogStore } = this.props;
    let body = JSON.parse(snippet.body);

    let { type } = draftStore;

    Object.keys(body.entityMap).forEach((x) => {
      let { field } = body.entityMap[x].data;
      let _field = field.replace(this.prefix, '').replace(this.guid, '');

      body.entityMap[x].data.field = `${type}.data.${_field}${uuid()}`;
    });

    body = this.processFormulaVariables(body);

    draftStore.insertTemplateAndUpdate(body);
    dialogStore.open = false;
  }

  processFormulaVariables(body) {
    const formulaKeys = Object.keys(body.entityMap).filter((x) =>
      body.entityMap[x].data.hasOwnProperty('formulakey')
    );

    const formulas = Object.keys(body.entityMap).filter((x) =>
      body.entityMap[x].data.hasOwnProperty('formula')
    );

    if (formulaKeys.length > 0) {
      let snippetName = this.props.snippet.name.trim().toLowerCase().replace(/\W+/gim, '_');
      if (!isNaN(snippetName.charAt(0))) snippetName = '_' + snippetName;
      snippetName = this.getSnippetName(snippetName);

      // prefix formula variable keys with snippet name + number
      formulaKeys.forEach((x) => {
        let { formulakey } = body.entityMap[x].data;
        if (formulakey) {
          body.entityMap[x].data.formulakey = `${snippetName}_${formulakey}`;
        }
      });

      // update prefixes on formulas
      formulas.forEach((f) => {
        let { formula } = body.entityMap[f].data;
        if (formula) {
          const prefixedFormula = formula.replace(/[A-Z_](\w?)+/gim, (x) => {
            if (this.props.draftStore.reservedFormulaKeys.includes(x)) return x;
            return `${snippetName}_${x}`;
          });
          body.entityMap[f].data.formula = prefixedFormula;
        }
      });
    }

    return body;
  }

  snippetNameExists(snippetName) {
    return !!Object.values(this.props.draftStore.rawTemplate.get('entityMap') || {}).some(
      ({ data }) => !!data.formulakey && data.formulakey.indexOf(snippetName) >= 0
    );
  }

  getSnippetName(snippetName) {
    let i = 0;
    while (this.snippetNameExists(snippetName)) {
      i++;
      snippetName = snippetName + (i > 0 ? i.toString() : '');
    }
    return snippetName;
  }
}

export default SnippetItem;
